/**
 * Modul Checkout Steps > Participants
 */

import {
	needJquery, extend
} from '../../../../shared/utils/index';


import SelectorEngine from '../../../../shared/dom/selector-engine';
import Manipulator from "../../../../shared/dom/manipulator";

import MultipleSelect from '../../../components/overwrites/form/elements/multi-select';
import {validateCheckoutButton} from '../index';

// ------
// Private
// ------

const $                  = needJquery();
const CHECKOUT_NAME      = 'participants';
const CHECKOUT_CONTAINER = SelectorEngine.findOne(`[data-checkout="${CHECKOUT_NAME}"]`);
const CHECKOUT_BUTTONS   = SelectorEngine.find(`[data-user-validation="${CHECKOUT_NAME}"]`);

const initParticipantsSelect = () => {
	const SELECT_FIELD = SelectorEngine.findOne(`.select-${CHECKOUT_NAME}`, CHECKOUT_CONTAINER);

	if(SELECT_FIELD) {
		const multiSelect = new MultipleSelect($(SELECT_FIELD), {
			maxItems    : Manipulator.getDataAttribute(SELECT_FIELD, 'max') ? parseInt(Manipulator.getDataAttribute(SELECT_FIELD, 'max')) : false,
			customEvents: {
				afterInit: (multiSelectApi) => {
					validate(multiSelectApi);
				},
				afterSelect: (multiSelectApi) => {
					validate(multiSelectApi);
				},
				afterDeselect: (multiSelectApi) => {
					validate(multiSelectApi);
				}
			}
		});
	}
};

const validate = (api) => {
	if(CHECKOUT_BUTTONS.length) {
		for(const ELEMENT of CHECKOUT_BUTTONS) {
			validateCheckoutButton(ELEMENT, api._api.selectionCounter);
		}
	}
};

// ------
// Public
// ------

const init = () => {
	if(CHECKOUT_CONTAINER) {
		initParticipantsSelect();
	}
};

// ------
// Export
// ------

export default {
	init : init
};